import { render, staticRenderFns } from "./bo-video-player.vue?vue&type=template&id=c56e9c0e"
import script from "./bo-video-player.vue?vue&type=script&lang=js"
export * from "./bo-video-player.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports